import React, { useState } from "react";
import PropTypes from "prop-types";

import Pagination from "components/Pagination/Pagination";

export default function TargetsTable({ color, data }) {
  const [dataPerPage, setDataPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  const startIndex = currentPage * dataPerPage;
  const paginatedData = data.slice(startIndex, startIndex + dataPerPage);

  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow rounded" + (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th className="px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-white text-blueGray-500 border-blueGray-100">
                  Month
                </th>
                <th className="px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-white text-blueGray-500 border-blueGray-100">
                  Amount (€)
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((target, index) => (
                <tr key={index}>
                  <th className="border-t-0 px-6 bg-white align-middle border-l-0 border-r-0 whitespace-nowrap p-4 text-left flex items-center">
                    <p>{target.month}</p>
                  </th>
                  <td className="border-t-0 px-6 bg-white align-middle border-l-0 border-r-0 whitespace-nowrap p-4">{target.target_amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          totalRows={data.length}
          dataPerPage={dataPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setDataPerPage={setDataPerPage}
        />
      </div>
    </>
  );
}

TargetsTable.defaultProps = {
  color: "light",
};

TargetsTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
